import {DocumentEN} from "./document/en";
import {ProcessEN} from "./process/en";
import {workplaceWork} from "./work/en";
import {SequenceTaskEN} from "./sequence/en";
import {OfficialDispatchEN} from "./officical-dispatch/en";
import {CalendarEN} from "./Calendar/en";
import {RecurringTaskEN} from "./recurring/en";

export const WorkPlaceEN = {
    "workplace": "WORKPLACE",
    ...ProcessEN,
    ...DocumentEN,
    ...workplaceWork,
    ...SequenceTaskEN,
    ...OfficialDispatchEN,
    ...CalendarEN,
    ...RecurringTaskEN
}